// @ts-expect-error package is not typed
import { withOverrideFromContext, withStyleSheetOverride } from '@klarna/higher-order-components';
import { compose, setDisplayName } from 'recompose';
// @ts-expect-error package is not typed
import omitProps from '@hocs/omit-props';
// @ts-expect-error package is not typed
import dontUseStyle from '@bubble-ui/hoc-dont-use-style';
// @ts-expect-error package is not typed
import withStyleSheetOverrideFromContext from '@bubble-ui/hoc-with-stylesheet-override-from-context';
export default ((displayName, getDefaultStyleSheet) => {
  var hocs = [dontUseStyle(displayName), withStyleSheetOverrideFromContext, setDisplayName(displayName), withStyleSheetOverride(getDefaultStyleSheet), setDisplayName(displayName), withOverrideFromContext, setDisplayName(displayName), omitProps('hasTheme')];
  return compose(...hocs);
});
//# sourceMappingURL=index.js.map